module.exports = __webpack_public_path__ + "static/media/01.6a516ece.jpg";